import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PublicRoutes = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  // Get the next path from query params or default to "/"
  const next = new URLSearchParams(location.search).get("next") || "/";

  if (isAuthenticated) {
    // Redirect to the next path if authenticated
    return <Navigate to={next} replace />;
  }

  return <Outlet />;
};  

export default PublicRoutes;
